/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a template
 * @export
 * @interface UpdateTemplateRequest
 */
export interface UpdateTemplateRequest {
    /**
     * Content of the template
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the UpdateTemplateRequest interface.
 */
export function instanceOfUpdateTemplateRequest(value: object): value is UpdateTemplateRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateTemplateRequestFromJSON(json: any): UpdateTemplateRequest {
    return UpdateTemplateRequestFromJSONTyped(json, false);
}

export function UpdateTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function UpdateTemplateRequestToJSON(json: any): UpdateTemplateRequest {
    return UpdateTemplateRequestToJSONTyped(json, false);
}

export function UpdateTemplateRequestToJSONTyped(value?: UpdateTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

